export const ACTION_SET_LIST_USER            = 'ACTION_SET_LIST_USER';

//ENCUESTAMULTIPLE
